import { render, staticRenderFns } from "./HuaXiang.vue?vue&type=template&id=4dee45a6&scoped=true&"
import script from "./HuaXiang.vue?vue&type=script&lang=js&"
export * from "./HuaXiang.vue?vue&type=script&lang=js&"
import style0 from "./HuaXiang.vue?vue&type=style&index=0&id=4dee45a6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dee45a6",
  null
  
)

export default component.exports